<template>
  <div class="" v-if="isLoading">
    <Loading />
  </div>

  <div v-else>
    <BethsLayout>
      <div class="flex flex-col justify-center min-h-600">
        <div
          class="m-auto my-10 border-2 border-gray-300 shadow-md rounded-md w-12/12 lg:w-6/12 md:w-8/12 sm:10/12"
        >
          <div class="px-8 py-8 rounded-xl">
            <h1
              id="login-title"
              name="login-title"
              class="mt-2 flex flex-wrap content-center font-bold text-2xl"
            >
              <div class="font-normal">You are now logged out.</div>
            </h1>

            <div class="mt-4 mb-5" v-if="siteCode">
              <p class="font-light text-base text-gray-400">
                Want to login again?
                <a
                  @click="loginClick"
                  class="font-bold underline text-lg text-blue-500 cursor-pointer"
                  data-cy="RegisterPageLink"
                >
                  Login
                </a>
              </p>
            </div>

            <ErrorDisplay
              :label="loginErrorLabel"
              id="login-error"
              :message="loginError"
              :message-is-html="true"
              :isVisible="loginError != null"
            />
          </div>
        </div>
      </div>
    </BethsLayout>
  </div>
</template>

<script setup lang="ts">
import { useUserStore } from "../store/userStore";
import { ref, onMounted, onActivated } from "vue";
import { useRouter, useRoute } from "vue-router";

const userStore = useUserStore();
const router = useRouter();
const route = useRoute();

let isLoading = ref(false);
let siteCode = ref<string | null>(null);

onMounted(loadData);
onActivated(() => loadData);

async function loadData() {
  siteCode.value = route.params["sitecode"]?.toString();
  isLoading.value = true;
  await logout();
  isLoading.value = false;
}

let loginError = ref<string | null>(null);
let loginErrorLabel = ref<string | null>(null);

async function logout() {
  await userStore.logoff();
  console.log("User successfully logged out");
}

function loginClick() {
  router.push(`/${siteCode.value}/login`);
}
</script>
